// Columns.tsx
// @ts-nocheck
import { Column } from 'react-table'
import { InfoCell } from './InfoCell'
import { LastLoginCell } from './LastLoginCell'
import { TwoStepsCell } from './TwoStepsCell'
import { ActionsCell } from './ActionsCell'
import { SelectionCell } from './SelectionCell'
import { CustomHeader } from './CustomHeader'
import { SelectionHeader } from './SelectionHeader'
import { Data } from '../../core/_models'

const Columns: ReadonlyArray<Column<Data>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <SelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title=" No" className="min-w-125px" />
    ),
    id: 'no',
    Cell: ({ ...props }) => <>{props.row.index + 1}</>,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Title" className="min-w-125px" iconName="file-text" />
    ),
    accessor: 'title',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Client Name" className="min-w-125px" iconName="user" />
    ),
    accessor: 'clientName',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Phone Number" className="min-w-125px" iconName="phone" />
    ),
    accessor: 'phoneNumber',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Category" className="min-w-125px" iconName="tag" />
    ),
    accessor: 'category',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Status" className="min-w-125px" iconName="info" />
    ),
    accessor: 'status',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Actions" className="text-end min-w-100px" iconName="settings" />
    ),
    id: 'actions',
    Cell: ({ ...props }) => {
      const { id, title } = props.data[props.row.index]
      return <ActionsCell id={id} title={title} />
    },
  },
]

export { Columns }
